var team25 = [
  [
    {
      name: "Prof. Priyanka Ghosh",
      post: "HOD",
      fb: "https://www.facebook.com/profile.php?id=100005799362676",
      insta: "https://www.instagram.com/govind_gupta_46/",
      linkedin:
        "https://www.linkedin.com/in/priyanka-ghosh-33173314/?originalSubdomain=in",
      website: "https://iitk.ac.in/new/priyanka-ghosh",
      mail: "mailto:priyog@iitk.ac.in",
      image: "/team/team23/priyanka-ghosh-iitk.jpg",
    },
    {
      name: "Prof.Subhadip Das",
      post: "Faculty Advisor",
      fb: " ",
      insta: " ",
      linkedin: "https://www.linkedin.com/in/sdas-uw/",
      website: "https://www.iitk.ac.in/new/subhadip-das",
      mail: "mailto:subhadipd@iitk.ac.in",
      image: "/team/team25/Subhadip_Das_Faculty_Advisor.jpg",
    },
  ],
  [
    {
      id: "1",
      name: "Yash Kumar",
      post: " Events",
      fb: "https://www.facebook.com/profile.php?id=100055586395659",
      insta: "https://www.instagram.com/yashk_1278?igsh=MTBnNTN2Nmw0bjBmag==",
      linkedin: "https://www.linkedin.com/in/yash-kumar-51279b295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:yashkmr23@iitk.ac.in",
      image: "/team/team25/Yash Kumar_events.jpg",
    },
    {
      id: "2",
      name: "Neela",
      post: " Web ",
      fb: " ",
      insta: "https://www.instagram.com/_n.e.e.l.a.0.2/",
      linkedin: "https://www.linkedin.com/in/neela-%F0%9F%99%82-a39311240?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:neela23@iitk.ac.in",
      image: "/team/team25/Neela_Web.jpg",
    },
    {
      id: "3",
      name: "Himavarsha Kotnana",
      post: " Design ",
      fb: " ",
      insta: "https://www.instagram.com/varsha_20_13?igsh=MTF1Z2t2NnRodnNxdQ==",
      linkedin: "https://www.linkedin.com/in/himavarsha-kotnana?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:hkotnana23@iitk.ac",
      image: "/team/team25/Himavarsha_Kotnana_Design.jpg",
    },
    {
      id: "5",
      name: "S Neha Patel",
      post: "Marketing & Finance ",
      fb: "https://www.facebook.com/share/19iCgNhmYC/",
      insta: "https://www.instagram.com/nehapatel_3405?igsh=Y2J6enVxcm9zNWVj",
      linkedin: "https://www.linkedin.com/in/shenkesi-neha-patel-a4276b289?",
      mail: "mailto:nehaps23@iitk.ac.in",
      image: "/team/team25/Neha Patel_Finance.jpg",
    },
    {
      id: "6",
      name: "Nishant Singh ",
      post: "Marketing & Finance ",
      fb: "https://www.facebook.com/profile.php?id=100025239159894",
      insta:
        "https://www.instagram.com/nishantsiingh?igsh=MTNxZHFoMmR2ZTR4eg==",
      linkedin: "https://www.linkedin.com/in/nishant-singh-429a582a3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:snishant23@iitk.ac.in",
      image: "/team/team25/Nishant Singh_Finance.jpg",
    },
    {
      id: "7",
      name: "Laksh Verma",
      post: "Media and Content",
      fb: " ",
      insta: "https://www.instagram.com/tyecole26530?igsh=MWcza2R0Z3VjOXhsdA==",
      linkedin:
        "https://www.linkedin.com/in/laksh-verma-32a179207?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      mail: "mailto:lakshv23@iitk.ac.in",
      image: "/team/team25/Laksh Verma_Media.jpg",
    },
    {
      id: "8",
      name: "Rohit Kumawat ",
      post: "Events ",
      fb: "https://www.facebook.com/rohit.kumawat.35380399",
      insta: "https://www.instagram.com/rohitkumawat007.official?igsh=d2llanN6N283OWNo",
      linkedin: "https://www.linkedin.com/in/rohit-kumawat-278b571a9",
      mail: "mailto:rohitu24@iitk.ac.in",
      image: "/team/team25/Rohit Kumawat_events.jpg",
    },
  ],
  [
  {
    id: "1",
    name: "Jayendra Singh",
    post: "Web",
    fb: "",
    insta: "https://www.instagram.com/the_majestic_jatin_27/?__pwa=1#",
    linkedin: "https://www.linkedin.com/in/jayendra-singh-51b001322",
    mail: "mailto:jayendras24@iitk.ac.in",
    image: "/team/team25/Jayendra_web.jpeg"
  },
 {
    id: "2",
    name: "Nikhil Prajapati",
    post: "Web",
    fb: "",
    insta: "nikhilprajapati-21",
    linkedin: "https://www.linkedin.com/in/nikhil-prajapati-15bbab298",
    mail: "mailto:nikhilr24@iitk.ac.in",
    image: "/team/team25/Nikhil.jpg"
  },
  {
    id: "3",
    name: "Pampana Sashank",
    post: "Web",
    fb: "",
    insta: "sashankp_06",
    linkedin: "https://www.linkedin.com/in/pampana-sashank-0a8844365",
    mail: "mailto:sashankp24@iitk.ac.in",
    image: "/team/team25/Sashank_Web.jpg"
  },
  {
    id: "4",
    name: "Y Krishna Poojitha",
    post: "Marketing & Finance",
    fb: "",
    insta: "https://www.instagram.com/ykpoojitha_1306",
    linkedin: "https://www.linkedin.com/in/krishna-poojitha-yadavalli-19293b330",
    mail: "mailto:ykrishnap24@iitk.ac.in",
    image: "/team/team25/Krishna_MF.jpg"
  },
  {
    id: "5",
    name: "Shiva Sri Sarkani",
    post: "Design",
    fb: "Shiva sri",
    insta: "https://www.instagram.com/shiva_sri9/",
    linkedin: "https://www.linkedin.com/in/shiva-sri-401258378",
    mail: "mailto:shivasri24@iitk.ac.in",
    image: "/team/team25/Shiva_Design.jpg"
  },
  {
    id: "6",
    name: "Arnab Patra",
    post: "Events",
    fb: "",
    insta: "https://www.instagram.com/arnab77_/",
    linkedin: "https://www.linkedin.com/in/arnab-patra-056b9532b",
    mail: "mailto:arnabt24@iitk.ac.in",
    image: "/team/team25/Arnab_Event.jpg"
  },
  {
    id: "7",
    name: "Yash Soni",
    post: "Event",
    fb: "https://www.facebook.com/profile.php?id=100071227735973",
    insta: "https://www.instagram.com/soni2006yash/",
    linkedin: "https://in.linkedin.com/in/yash-soni-905016331",
    mail: "mailto:yashs24@iitk.ac.in",
    image: "/team/team25/Yash_Event.jpg"
  },
  {
    id: "8",
    name: "Mehar Fatima",
    post: "Marketing & Finance",
    fb: "",
    insta: "https://www.instagram.com/meharfatima05/",
    linkedin: "https://www.linkedin.com/in/mehar-fatima-490b27220",
    mail: "mailto:meharf24@iitk.ac.in",
    image: "/team/team25/Mehar_MF.jpg"
  },
  {
    id: "9",
    name: "Girish Bhojwani",
    post: "Media and Content",
    fb: "",
    insta: "https://www.instagram.com/girish.iitk/",
    linkedin: "https://www.linkedin.com/in/girish-bhojwani-b1315a323",
    mail: "mailto:girishb24@iitk.ac.in",
    image: "/team/team25/Girish_Media.jpg"
  },
  {
    id: "10",
    name: "Vihan Purohit",
    post: "Design",
    fb: "",
    insta: "https://www.instagram.com/vihanpurohit_03/",
    linkedin: "",
    mail: "mailto:vihanp24@iitk.ac.in",
    image: "/team/team25/Vihan_Design.jpg"
  },
  {
    id: "11",
    name: "Aluri Hyndavi Sai",
    post: "Finance and Marketing",
    fb: "",
    insta: "https://www.instagram.com/alurihyndavi/",
    linkedin: "https://www.linkedin.com/in/hyndavi-sai-aluri-58a944367",
    mail: "mailto:alurih24@iitk.ac.in",
    image: "/team/team25/Hyndavi_MF.jpeg"
  },
  {
    id: "12",
    name: "Chitrank Sinha",
    post: "Events",
    fb: "",
    insta: "https://www.instagram.com/_.itz_chiku_/",
    linkedin: "",
    mail: "mailto:chitranks24@iitk.ac.in",
    image: "/team/team25/Chitrank_Event.jpg"
  },
  {
    id: "13",
    name: "Saksham",
    post: "Events",
    fb: "",
    insta: "#",
    linkedin: "https://www.linkedin.com/feed/",
    mail: "mailto:saksham24@iitk.ac.in",
    image: "/team/team25/Saksham_Event.jpg"
  },
  {
    id: "14",
    name: "Kartikey Agarwal",
    post: "Design",
    fb: "Nope",
    insta: "https://www.instagram.com/agarwal.k._/",
    linkedin: "https://www.linkedin.com/in/kartikey-agarwal-48769b31b",
    mail: "mailto:akartikey24@iitk.ac.in",
    image: "/team/team25/Kartikey_Design.jpg"
  },
  {
    id: "15",
    name: "Srashti Singh",
    post: "Design",
    fb: "",
    insta: "https://www.instagram.com/srashtiiiii/",
    linkedin: "https://www.linkedin.com/in/srashti-singh-4066a42b9",
    mail: "mailto:srashtis24@iitk.ac.in",
    image: "/team/team25/Srashti_Design.jpg"
  },
  {
    id: "16",
    name: "Anirudh Kosley",
    post: "Marketing & Finance",
    fb: "https://www.facebook.com/anirudh.kumar.5099/",
    insta: "anirudh_kosley",
    linkedin: "https://www.linkedin.com/in/anirudh-kosley-5b5397155",
    mail: "mailto:anirudhk24@iitk.ac.in",
    image: "/team/team25/Anirudh_MF.jpeg"
  },
  {
    id: "17",
    name: "Shaik Kamoosh",
    post: "Events",
    fb: "https://www.facebook.com/profile.php?id=100094720843708",
    insta: "kamoosh_shaik",
    linkedin: "https://www.linkedin.com/in/kamooshshaik",
    mail: "mailto:kamooshsb24@iitk.ac.in",
    image: "/team/team25/Kamoosh_Geo.jpg"
  },
  {
    id: "18",
    name: "Jasmine Khalkho",
    post: "Media and Content",
    fb: "",
    insta: "https://www.instagram.com/_j_as_mine/",
    linkedin: "https://www.linkedin.com/in/jasminekhalkho",
    mail: "mailto:jasmine24@iitk.ac.in",
    image: "/team/team25/Jasmine_Media.jpg"
  },
  {
    id: "19",
    name: "Bishwas Kumar",
    post: "Marketing & Finance",
    fb: "https://www.facebook.com/vishwas.kumarmishra",
    insta: "https://www.instagram.com/free4tech/",
    linkedin: "https://www.linkedin.com/in/bishwas-kumar-991431126",
    mail: "mailto:bishwas24@iitk.ac.in",
    image: "/team/team25/Bishwas_MF.jpeg"
  },
  {
    id: "20",
    name: "Aditi Sahu",
    post: "Marketing & Finance",
    fb: "",
    insta: "https://www.instagram.com/tashu_aditi/?__pwa=1#",
    linkedin: "https://www.linkedin.com/in/aditi-sahu911",
    mail: "mailto:aditisahu24@iitk.ac.in",
    image: "/team/team25/Aditi_MF.jpg"
  }
],

];

module.exports = team25;
